import { HeatMapColorRange } from "@pimo/pimo-components";

import {
  DISTRIBUTION_CHANNEL_OE_MATRIX_DARK_TEXT,
  DISTRIBUTION_CHANNEL_OE_MATRIX_LIGHT_TEXT,
  getDistributionChannelOeMatrixShade,
} from "../../../constants";

const foreColorFor = (lightness: number) =>
  lightness <= 55
    ? DISTRIBUTION_CHANNEL_OE_MATRIX_LIGHT_TEXT
    : DISTRIBUTION_CHANNEL_OE_MATRIX_DARK_TEXT;

// Fixed count-bucket boundaries and their lightness (%), all sharing one
// hue/saturation — the lower the lightness, the higher the business-app
// count. `to: null` marks the open-ended top bucket. Business-app counts
// per channel/OE rarely swing wildly between reporting cycles, so fixed
// thresholds (rather than scaling to the observed max) keep a cell's color
// meaning stable release over release (#2608).
const BUCKETS: { from: number; to: number | null; lightness: number }[] = [
  { from: 0, to: 0, lightness: 94 },
  { from: 1, to: 4, lightness: 82 },
  { from: 5, to: 9, lightness: 72 },
  { from: 10, to: 19, lightness: 62 },
  { from: 20, to: 34, lightness: 52 },
  { from: 35, to: 49, lightness: 42 },
  { from: 50, to: 99, lightness: 32 },
  { from: 100, to: null, lightness: 20 },
];

/**
 * Builds the discrete, fixed color bands the "Business Apps per
 * Distribution Channel and OE" heat map (#2608) uses to shade its cells.
 * Every band is a shade of the same base hue, only lightness changes,
 * getting darker as the business-app count grows.
 */
export const getBusinessAppCountColorScaleRanges = (): HeatMapColorRange[] =>
  BUCKETS.map(({ from, to, lightness }) => ({
    from,
    to: to ?? Number.MAX_SAFE_INTEGER,
    color: getDistributionChannelOeMatrixShade(lightness),
    foreColor: foreColorFor(lightness),
    name:
      from === 0
        ? "0 business apps"
        : to === null
          ? `${from}+`
          : `${from}-${to}`,
  }));
